import { PrimaryButton } from "@common/Buttons";
import uploadIcon from "@assets/icons/upload.svg";
import uploadActiveIcon from "@assets/icons/upload_active.svg";
import CustomSelect from "@common/CustomSelect";
import { useEffect, useState } from "react";
import UploadDrawer from "./UploadDrawer";
import { getDateToDisplay, getLoggedInUser } from "@utils/helpers";
import { useFetchYearsQuery } from "@store/master";

export default function TabHeader({
  lastUpdateDate = "",
  onMonthChange,
  month,
  onYearChange,
  year,
  monthOptions,
  yearOptions,
  drawerInputsToShow,
  url,
  activeTab,
  saveAndGenerateUrls,
  redirectUrl,
  onProductChange,
  product,
  productOptions,
  filtersToShow,
  useDefaultSheetNames,
  previewSelectInputFields,
  previewLockInputFields,
  fetchProductsWiseData,
  subTypeId,
}) {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const { user } = getLoggedInUser();
  const { data: years } = useFetchYearsQuery(
    { SubTypeMasterId: subTypeId },
    { refetchOnMountOrArgChange: true }
  );

  useEffect(() => {
    if (years?.lastestYearMonth && fetchProductsWiseData) {
      onMonthChange(years.lastestYearMonth.month);
    }
  }, [years]);

  return (
    <div className="border border-border rounded-lg p-2 md:p-3.5 gap-2 flex md:flex-row flex-col justify-between items-stretch md:items-center">
      <div className="flex flex-row justify-between md:flex-col">
        <label className="text-sm font-medium leading-6 text-text-main">
          Upload Files
        </label>
        <span className="text-xs font-medium leading-6 text-text-tint">
          Last updated on: {getDateToDisplay(lastUpdateDate)}
        </span>
      </div>
      {/* action buttons */}
      <div className="flex items-center justify-center flex-wrap gap-2.5">
        {/* month */}
        {filtersToShow.includes("month") ? (
          <CustomSelect
            onChange={onMonthChange}
            value={month}
            options={monthOptions}
          />
        ) : null}

        {/* year */}
        {filtersToShow.includes("year") ? (
          <CustomSelect
            onChange={onYearChange}
            value={year}
            options={years?.data?.map((year) => ({ label: year, value: year }))}
          />
        ) : null}

        {/* product */}
        {filtersToShow.includes("product") ? (
          <CustomSelect
            onChange={onProductChange}
            value={product}
            options={productOptions}
            placeholder="Select Product"
          />
        ) : null}

        {user.isAdmin ? (
          <PrimaryButton
            onClick={() => setIsDrawerOpen(true)}
            icon={uploadIcon}
            activeIcon={uploadActiveIcon}
          >
            Upload file
          </PrimaryButton>
        ) : null}

        <UploadDrawer
          drawerInputsToShow={drawerInputsToShow}
          isOpen={isDrawerOpen}
          onClose={() => setIsDrawerOpen(false)}
          months={monthOptions}
          years={yearOptions}
          products={productOptions}
          url={url}
          activeTab={activeTab}
          saveAndGenerateUrls={saveAndGenerateUrls}
          redirectUrl={redirectUrl}
          useDefaultSheetNames={useDefaultSheetNames}
          previewSelectInputFields={previewSelectInputFields}
          previewLockInputFields={previewLockInputFields}
          fetchProductsWiseData={fetchProductsWiseData}
        />
      </div>
    </div>
  );
}
